<template>
  <section class="offset-top-1">
    <h1 class="h4">{{ $t('cita.contracting_party') }}</h1>

    <div class="align">
      <img
        v-if="hasImage"
        :src="`delegates/barring/content/businesspartner/${partnerId}`"
        alt=""
        aria-hidden="true"
        class="logo offset-right-1"
        style="max-width: 130px; max-height: 60px;"
      />
      <span>{{ partnerName }}</span>

      <button class="info-button offset-left-1" @click="onOpenDetails">
        <span class="sr-only">{{ $t('cita.tooltipBtnDetails') }}</span>
        <img src="@/assets/images/barring/information_graphical.svg" width="30" height="30" alt="" aria-hidden="true" :title="$t('cita.tooltipBtnDetails')" />
      </button>
    </div>
    <h2>{{ contentName }}</h2>
    <b v-if="price" data-test="price"> {{ $t('cita.price') }}: <VPrice :footnotes="footnotes"/></b>

    <hr />
    <VInfo v-if="modalInfo" v-bind="modalInfo" @close="onCloseDetails" />
  </section>
</template>

<script>
import { mapState } from 'vuex';
import VPrice from '@/components/Cita/Price';
import VInfo from '@/components/Barring/Info';

export default {
  name: 'CitaHeader',

  components: {
    VPrice,
    VInfo,
  },

  props: {
    footnotes: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      modalInfo: null,
    };
  },

  computed: {
    ...mapState('cita', ['partnerName', 'partnerId', 'hasImage', 'price', 'contentName']),
  },

  methods: {
    onOpenDetails() {
      this.modalInfo = { partnerId: this.partnerId, hasImage: this.hasImage, type: 'businesspartner' };
      this.$webtrekk.link('oeffne_partner_details');
    },

    onCloseDetails() {
      this.modalInfo = null;
      this.$webtrekk.link('schliesse_partner_details');
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@scss';

.info-button {
  padding: 0;
  background: transparent;
  border: none;
}

@media screen and (min-width: #{$grid-medium-min}px) {
  .align {
    display: flex;
    align-items: center;
  }
}
</style>
